let timer: any;
const debounce = (cb: any, timeout: number) => {
  clearTimeout(timer);
  timer = setTimeout(cb, timeout);
};
export default debounce;
